import React from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
// import DocumentTitle from 'react-document-title'
import { config } from 'config'

// import RequestDemoModal from '../components/RequestDemoModal'
import PlansSection from '../components/PlansSection'
import ContactForm from './_contact_form'

import { doScrolling } from '../utils/scrolling.js'

import _ from 'lodash'

export default class Index extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // requestDemoModalIsOpen: false,
    };
    this._scrollToContactForm  = this._scrollToContactForm.bind(this);
    // this._openRequestDemoModal  = this._openRequestDemoModal.bind(this);
    // this._closeRequestDemoModal = this._closeRequestDemoModal.bind(this);
  }

  _scrollToContactForm() {
    let element = ReactDOM.findDOMNode(this.contactFormRef);
    doScrolling(element, 700);
  }

  // /* MODAL
  // --===================================================-- */
  // _openRequestDemoModal() {
  //   this.setState({requestDemoModalIsOpen: true});
  // }
  //
  // _closeRequestDemoModal() {
  //   this.setState({requestDemoModalIsOpen: false});
  // }

  render () {
    let logo = "/images/logo.svg",
        landingImage = "/images/landing-img.svg",
        snoozeIcon = "/images/snz-icon.svg",
        bucketIcon = "/images/bck-icon.svg",
        emailIcon = "/images/eml-icon.svg",
        chromeIcon = "/images/crm-icon.svg",
        cogIcon = "/images/cog-icon.svg",
        phoneIcon = "/images/phn-icon.svg",
        profilePicture = "/images/prof-pic.png";

    return (
      <div className="HomeView">

        <header>
          <div className="SetterBase-row">
            <div className="SetterBase-col SetterBase-medium-c-4 logo-cage">
              <a className="logo" href="/">
                <img src={logo}/>
              </a>
            </div>
            <div className="SetterBase-spacer-short visible-xs visible-sm"></div>
            <div className="SetterBase-col SetterBase-medium-c-8 nav-cage">
              <ul className="nav inline-list">
                <li><a className="feature-btn" href="#features">FEATURES</a></li>
                <li><a className="feature-btn" href="#pricing">PRICING</a></li>
                {/* <li><a href="#">ABOUT</a></li> */}
                <li><a href="http://app.setter.io/login" className="signup-btn setter-btn">LOGIN</a></li>
                {/* <li><a href="http://app.setter.io/register" className="signup-btn setter-btn">SIGN UP</a></li> */}
              </ul>
            </div>
          </div>
        </header>

        <div className="hero">
          <div className="SetterBase-row">
            <div className="SetterBase-center-col SetterBase-c-8 text-center">
              <h1 className="title">The Recruiting CRM</h1>
              <div className="SetterBase-spacer"></div>
              <p className="text-center sub-title">Setter makes Candidate Relationship Management simple. Never let a great candidate fall through the cracks or be forgotten again!</p>
              <div className="SetterBase-spacer-tall"></div>
              <a className="tryout-btn setter-btn" onClick={this._scrollToContactForm}>REQUEST A DEMO</a>
            </div>
          </div>

          <div className="SetterBase-spacer-giant"></div>

          <div className="SetterBase-img-box text-center">
            <img src={landingImage}/>
          </div>
        </div>

        <div className="curva"></div>

        <div id="features" className="feature-box">
          <div className="SetterBase-row">
            <div className="SetterBase-col SetterBase-c-12">
              <h2 className="title text-center">FEATURES</h2>
            </div>
          </div>

          <div className="SetterBase-spacer-giant hidden-xs hidden-sm"></div>
          <div className="SetterBase-spacer-tall"></div>

          <div className="SetterBase-row">
            <div className="SetterBase-col SetterBase-medium-c-4 SetterBase-large-text-left SetterBase-text-center">

              <img src={snoozeIcon}/>

              <h3 className="name">Snooze</h3>
              <hr className="separator"/>
              <p className="content">
                Want to be reminded to reach out to someone in a few weeks? Snooze them. Found someone great who wants to reconnect in 6 months? You guessed it! This is one of our most loved features.
              </p>
              <div className="SetterBase-spacer-tall visible-xs visible-sm"></div>
            </div>
            <div className="SetterBase-col SetterBase-medium-c-4 SetterBase-large-text-left SetterBase-text-center">

              <img src={bucketIcon}/>

              <h3 className="name">Buckets</h3>
              <hr className="separator"/>
              <p className="content">
                Buckets help you keep everyone organized. Buckets can be used to group people for a position or by a skillset. They are the power filter. Put people in as many buckets as you need. We have plenty.
              </p>
              <div className="SetterBase-spacer-tall visible-xs visible-sm"></div>
            </div>
            <div className="SetterBase-col SetterBase-medium-c-4 SetterBase-large-text-left SetterBase-text-center">

              <img src={emailIcon}/>

              <h3 className="name">Email</h3>
              <hr className="separator"/>
              <p className="content">
                We play nicely with email. Setter integrates with your email and can automatically pull in all emails you exchange with a prospect. You can even send email from Setter and send bulk email using templates. (Coming soon, Enterprise plans only)
              </p>
              <div className="SetterBase-spacer-tall visible-xs visible-sm"></div>
            </div>
          </div>

          <div className="SetterBase-spacer-giant hidden-xs hidden-sm"></div>

          <div className="SetterBase-row">
            <div className="SetterBase-col SetterBase-medium-c-4 SetterBase-large-text-left SetterBase-text-center">

              <img src={chromeIcon}/>

              <h3 className="name">Browser Plugin</h3>
              <hr className="separator"/>
              <p className="content">
                You spend a lot of time online searching and researching prospective candidates. Don't interrupt your workflow by switching tabs and copy-pasting. We do our best to automatically capture the information you need on someone and make it simple to add them to Setter.
              </p>
              <div className="SetterBase-spacer-tall visible-xs visible-sm"></div>
            </div>
            <div className="SetterBase-col SetterBase-medium-c-4 SetterBase-large-text-left SetterBase-text-center">

              <img src={cogIcon}/>

              <h3 className="name">Integrations</h3>
              <hr className="separator"/>
              <p className="content">
                We work with you not against you. Easy to set up and use integrations with your favorite Applicant Tracking Systems like Greenhouse, and of course chat applications like Slack.
              </p>
              <div className="SetterBase-spacer-tall visible-xs visible-sm"></div>
            </div>
            <div className="SetterBase-col SetterBase-medium-c-4 SetterBase-large-text-left SetterBase-text-center">

              <img src={phoneIcon}/>

              <h3 className="name">Mobile</h3>
              <hr className="separator"/>
              <p className="content">
                We have an iOS app in the works. Being able to add and search for your existing prospects while you are out and about is invaluable. Let us know if you are interested in this.
              </p>
              <div className="SetterBase-spacer-tall visible-xs visible-sm"></div>
            </div>
          </div>
        </div>

        <div className="SetterBase-spacer-giant"></div>
        <div className="SetterBase-spacer-giant"></div>


        <div className="client-box">
          <div className="SetterBase-spacer-giant"></div>
          <div className="SetterBase-row">
            <div className="SetterBase-col SetterBase-c-12 text-center">
              <h2 className="title text-center">WHAT OUR CUSTOMERS SAY</h2>
              <div className="SetterBase-spacer"></div>
              <div className="SetterBase-spacer-giant"></div>
              <div className="content-box">
                <div className="text-box">
                  <p>"Setter has changed my entire workflow. The ability to keep conversations and notes on prospects in one place is huge."</p>
                </div>

                <div className="separator-ver"></div>

                <div className="SetterBase-spacer-tall visible-xs visible-sm"></div>

                <div className="user-box">
                  <div className="img-box">
                    <img src={profilePicture}/>
                  </div>

                  <div className="SetterBase-spacer-short visible-xs visible-sm"></div>

                  <div className="id-box">
                    <h6 className="name">Marcus Smith</h6>
                    <h6 className="title">VP Talent</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SetterBase-spacer-giant"></div>
          <div className="SetterBase-spacer-tall"></div>
        </div>

        <PlansSection />

        {/*<div className="contact-box text-center">
                 <div className="SetterBase-row">
                    <div className="SetterBase-center-col SetterBase-c-8 text-center">
                      <h2 className="title">Contact Us</h2>
                      <div className="SetterBase-spacer"></div>
                      <p className="text-center sub-title">For any question or quote request, don't hesitate to contact us.</p>
                      <div className="SetterBase-spacer"></div>
                      <a className="contact-btn setter-btn" onClick={this._openRequestDemoModal}>CONTACT US</a>
                    </div>
                  </div>
                </div>*/}

        <ContactForm ref={(r) => this.contactFormRef = r} />


      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./index.js
 **/